import { render, staticRenderFns } from "./MerchantForm.vue?vue&type=template&id=8f64447c&"
import script from "./MerchantForm.vue?vue&type=script&lang=js&"
export * from "./MerchantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports